<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal create-notice-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Insert icons into announcements</h4>
                </div>
                <div class="modal-body  notice-icons">
                    <div class="input-group m-b">
                        <input type="text" class="form-control search-bar" name="search" [(ngModel)]="search" placeholder="Enter Keywords">
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-default" style="height: 38px;"><i class="fa fa-search"></i> Search</button>
                        </span>
                    </div>
                    <ul class="nav nav-tabs nav-justified">
                        <li class="uib-tab nav-item" [ngClass]="{'active': tab==0}">
                            <a (click)="tab = 0" class="nav-link mtv-primary-color">Shared Collection</a>
                        </li>
                        <li class="uib-tab nav-item"  [ngClass]="{'active': tab==1}">
                            <a (click)="tab = 1" class="nav-link mtv-primary-color">Private Collection</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" *ngIf="tab == 0">
                            <div class="icons-items" gallery-icons (change)="changed(data)">
                                <div class="item" *ngFor="let item of listSharedIcons; let index = index;">
                                    <div class="_wrap">
                                        <a class="_img" [href]="item.icon" gallery-item [title]="item.name">
                                            <img [src]="item.thumb">
                                            <span class="preview-icon"><i class="fa fa-search-plus"></i></span>
                                        </a>
                                        <a (click)="setImage(item.icon)" class="set-icon"><i class="fa fa-check-circle"></i></a>
                                    </div>
                                    <div class="_tags">
                                        {{item.tags.join(', ')}}
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="_wrap">
                                        <a class="_img" gallery-item [title]="'Title'">
                                            <img [src]="'https://www.w3schools.com/w3css/img_fjords.jpg'">
                                            <span class="preview-icon" (click)="noticesService.showAttachment({name:'lol', path: 'https://www.w3schools.com/w3css/img_fjords.jpg'})">
                                                <i class="fa fa-search-plus"></i>
                                            </span>
                                        </a>
                                        <a (click)="setImage('')" class="set-icon"><i class="fa fa-check-circle"></i></a>
                                    </div>
                                    <div class="_tags">
                                        boogaga
                                    </div>
                                </div>
                            </div>
                            <!--<pagination-tpl page-limit="pageLimit" page-num="page"></pagination-tpl>-->
                            <!--<pagination *ngIf="serviceRequestService.data.allServiceRequests.total && urlService.queryParams['page']" [total]="25"></pagination>-->
                            <pagination [total]="25"></pagination>
                        </div>
                        <div class="tab-pane active" *ngIf="tab == 1">
                            <div class="form-upload df jsb">
                                <div  class="btn btn-primary relative hide-overflow" style="width: 180px">
                                    <i class="fa fa-file-image-o"></i>
                                    <span *ngIf="!uploaderIcon.queue.length" (click)="launchFilePicker()">Upload icon</span>
                                    <span *ngIf="uploaderIcon.queue.length" [innerHtml]="uploaderIcon.queue[0].file.name"></span>
                                    <input #topLogoInput class="hidden-file-input" type="file" nv-file-select="" uploader="uploaderIcon">
                                </div>
                                <div style="flex: 1;margin: 0 5px;">
                                    <!--<input ui-select2="select2Options" type="hidden" style="width: 100%;"-->
                                           <!--name="tags" [(ngModel)]="file.tags" data-placeholder="Tags">-->
                                    <tag-select [data]="itemList" name="tags"
                                                          [(ngModel)]="selectedItems"
                                                          [settings]="settings"
                                                          (onSelect)="onItemSelect($event)"
                                                          (onDeSelect)="OnItemDeSelect($event)"
                                                          (onSelectAll)="onSelectAll($event)"
                                                          (onDeSelectAll)="onDeSelectAll($event)">
                                    </tag-select>
                                </div>
                                <button class="btn btn-primary btn-success" (click)="uploadIcon(file)" type="button"> Submit</button>
                            </div>
                            <div class="icons-items" gallery-icons (change)="changed(data)">
                                <div class="item" *ngFor="let item of listPrivateIcons; let index = index;">
                                    <div class="_wrap">
                                        <a class="_img" [href]="item.icon" gallery-item title="{{item.name}}">
                                            <img [src]="item.thumb">
                                            <span class="preview-icon"><i class="fa fa-search-plus"></i></span>
                                        </a>
                                        <a href (click)="setImage(item.icon)" class="set-icon"><i class="fa fa-check-circle"></i></a>
                                    </div>
                                    <div class="_tags">
                                        {{item.tags.join(', ')}}
                                        <span style="float: right;">
                                            <a href (click)="tags[index] = item.tags" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fa fa-pencil"></i>
                                            </a>
                                           <div style="top:0" class="dropdown-menu p-xs">
                                                <div class="form-group">
                                                    <label>Tags:</label>
                                                   <input class="edit-tags"
                                                          ui-select2="select2Options"
                                                          type="hidden"
                                                          name="tags"
                                                          [(ngModel)]="tags[index]"
                                                          data-placeholder="Tags">
                                                </div>
                                                <button class="btn btn-default btn-block" type="button" (click)="editTags(item, tags[index])">Save</button>
                                            </div>
                                       </span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="_wrap">
                                        <a class="_img" title="Title">
                                            <img [src]="'https://www.w3schools.com/w3css/img_fjords.jpg'">
                                            <span class="preview-icon" (click)="noticesService.showAttachment({name:'lol', path: 'https://www.w3schools.com/w3css/img_fjords.jpg'})">
                                                <i class="fa fa-search-plus"></i>
                                            </span>
                                        </a>
                                        <a (click)="setImage('')" class="set-icon"><i class="fa fa-check-circle"></i></a>
                                    </div>
                                    <div class="_tags">
                                        <!--{{item.tags.join(', ')}}-->Tags
                                        <span style="float: right;">
                                            <a href class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fa fa-pencil"></i>
                                            </a>
                                           <div style="top:0" class="dropdown-menu p-xs" (click)="$event.stopPropagation()">
                                               <tag-select [data]="itemList" name="tags2"
                                                           [(ngModel)]="selectedItems"
                                                           [settings]="smallSettings"
                                                           (onSelect)="onItemSelect($event)"
                                                           (onDeSelect)="OnItemDeSelect($event)"
                                                           (onSelectAll)="onSelectAll($event)"
                                                           (onDeSelectAll)="onDeSelectAll($event)">
                                                </tag-select>
                                                <button class="btn btn-default btn-block" type="button" (click)="editTags(item, tags[index])">Save</button>
                                            </div>
                                       </span>
                                    </div>
                                </div>
                            </div>
                            <!--<pagination *ngIf="serviceRequestService.data.allServiceRequests.total && urlService.queryParams['page']" [total]="25"></pagination>-->
                            <pagination [total]="25"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<zoom-image-modal *ngIf="noticesService.isViewAttachmentModalShow"></zoom-image-modal>



// WEBPACK FOOTER //
// /app/src/app/views/notices/choose-icon-modal/choose-icon-modal.component.html